// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/style/common.less
// module id = 519
// module chunks = 0